import { put, call, all, spawn, takeEvery } from 'redux-saga/effects';
import { inviteServices } from '../services/invite';
import * as types from '../constants/invite';
import * as actions from '../actions/invite';

// invite
function* apiInviteRequestWorker(action) {
  try {
    const result = yield call(inviteServices.apiInviteRequest, action);
    yield put(actions.apiInviteRequestSuccess(result, action));
    if (action.project_id !== null) {
      yield put(actions.apiGetPendingInvitationsRequest(action.token, 'PROJECT', action.project_id));
    } else {
      yield put(actions.apiGetPendingInvitationsRequest(action.token, 'ORG', action.collaborator_id));
    }
  } catch (err) {
    yield put(actions.apiInviteRequestFailed(err, action));
  }
}

function* apiInviteRequestWatcher() {
  yield takeEvery(types.API_INVITE_REQUEST, apiInviteRequestWorker);
}

function* apiCheckInvitationRequestWorker(action) {
  try {
    const result = yield call(inviteServices.apiCheckInvitation, action);
    yield put(actions.apiCheckInvitationSuccess(result, action));
  } catch (err) {
    yield put(actions.apiCheckInvitationFailed(err, action));
  }
}

function* apiCheckInvitationRequestWatcher() {
  yield takeEvery(
    types.API_CHECK_INVITATION_REQUEST,
    apiCheckInvitationRequestWorker,
  );
}

function* apiGetPendingInvitationsRequestWorker(action) {
  try {
    const result = yield call(inviteServices.apiGetPendingInvitations, action);
    if (action.selectedLevel === 'PROJECT') {
      yield put(actions.apiGetProjectPendingInvitationsSuccess(result, action));
    } else {
      yield put(actions.apiGetOrgPendingInvitationsSuccess(result, action));
    }
  } catch (err) {
    yield put(actions.apiGetPendingInvitationsFailed(err, action));
  }
}

function* apiGetPendingInvitationsRequestWatcher() {
  yield takeEvery(
    types.API_GET_PENDING_INVITATIONS_REQUEST,
    apiGetPendingInvitationsRequestWorker,
  );
}

function* apiResendInvitationRequestWorker(action) {
  try {
    const result = yield call(inviteServices.apiResendInvitation, action);
    yield put(actions.apiResendInvitationSuccess(result, action));
    if (action.invitationInformation.project !== null) {
      yield put(actions.apiGetPendingInvitationsRequest(action.token, 'PROJECT', action.invitationInformation.project));
    } else {
      yield put(actions.apiGetPendingInvitationsRequest(action.token, 'ORG', action.invitationInformation.organisation));
    }
  } catch (err) {
    yield put(actions.apiResendInvitationFailed(err, action));
  }
}

function* apiResendInvitationRequestWatcher() {
  yield takeEvery(
    types.API_RESEND_INVITATION_REQUEST,
    apiResendInvitationRequestWorker,
  );
}

// Read more information about root sagas in the documentation
// https://redux-saga.js.org/docs/advanced/RootSaga.html
export default function* inviteRootSaga() {
  const sagas = [
    apiInviteRequestWatcher,
    apiCheckInvitationRequestWatcher,
    apiGetPendingInvitationsRequestWatcher,
    apiResendInvitationRequestWatcher,
  ];

  yield all(
    sagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      }),
    ),
  );
}
